export const LEAVE_TYPES = [
    'Annual Leave',
    'Sick Leave',
    'Maternity Leave',
    'Important Leave',
    'Business Trip',
];

export const LEAVE_STATUSES = [
    'Pending',
    'Approved',
    'Rejected',
];

export const HR_OVERVIEW_ROLES = [
    'it',
    'super',
    'management',
];
